import ContactModelBase from '../_generated/modelBases/contact-model-base';

export default class ContactModel extends ContactModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
